import Dashboard from 'modules/dashboard';
import Subscribers from 'modules/subscribers';
import Transactions from 'modules/transactions';
import MaskNamesContent from 'modules/mask-names';
import UpgradeRequest from 'modules/upgrade-request';
import ForVerification from 'modules/for-verification';

import SubscriptionSettings from 'modules/subscription-settings';
import {
  ArrowsLeftRight,
  Buildings,
  ChartBar,
  GearSix,
  IdentificationBadge,
  ShieldCheck,
  SquaresFour,
} from '@phosphor-icons/react';

import BannedWords from 'modules/banned-words';
import RequestContent from 'modules/mask-names/Request';

import UserManagement from 'modules/access-control/user-management/Index';
import RolesAndPermissions from 'modules/access-control/roles-and-permissions/Index';

import Subscriptions from 'modules/mask-names/Subscriptions';
import Reports from 'modules/reports';
import ContentManagement from 'modules/cms';

export const routes = [
  {
    path: 'dashboard',
    title: 'Dashboard',
    component: Dashboard,
    icon: SquaresFour,
    permissions: ['dashboard'],
  },
  {
    path: 'subscribers',
    title: 'Agencies',
    component: Subscribers,
    icon: Buildings,
    withNested: true,
    subRoutes: [
      {
        path: 'dashboard',
        component: Subscribers,
        withNested: true,
        title: 'Agencies',
        permissions: ['subscriber'],
        tooltip:
          'Standard Dashboard — returns to the original agency list view',
      },
      {
        path: 'onboarding',
        component: ForVerification,
        withNested: true,
        title: 'onboarding',
        permissions: ['subscriber_requirement'],
      },
      {
        path: 'upgrade-plan-request',
        component: UpgradeRequest,
        withNested: true,
        title: 'upgrade plan request',
        permissions: ['-hidden-'], // HIDDEN
      },
    ],
  },
  {
    path: 'transactions',
    title: 'Transactions',
    component: Transactions,
    icon: ArrowsLeftRight,
    withNested: true,
    permissions: ['hidden'], // ['transaction'],
  },
  {
    path: 'mask-names',
    title: 'Mask Names',
    component: MaskNamesContent,
    icon: IdentificationBadge,
    withNested: true,
    subRoutes: [
      {
        path: 'masterlist',
        component: MaskNamesContent,
        withNested: true,
        title: 'Masterlist',
        permissions: ['sender_name'],
      },
      {
        path: 'request',
        component: RequestContent,
        withNested: true,
        title: 'For Approval',
        permissions: ['sender_name'],
      },
      {
        path: 'subscriptions',
        component: Subscriptions,
        withNested: true,
        title: 'subscriptions',
        permissions: ['sender_name'],
      },
    ],
  },
  {
    path: 'reports',
    title: 'Reports',
    component: Reports,
    icon: ChartBar,
    withNested: false,
    permissions: [],
  },
  {
    path: 'settings',
    title: 'Settings',
    component: SubscriptionSettings,
    icon: GearSix,
    withNested: true,
    subRoutes: [
      {
        path: 'plans',
        component: SubscriptionSettings,
        withNested: true,
        title: 'plans',
        permissions: ['hidden'], // HIDDEN
      },
      {
        path: 'banned-words',
        component: BannedWords,
        withNested: true,
        title: 'banned words',
        permissions: [],
      },
      {
        path: 'content-management',
        component: ContentManagement,
        withNested: true,
        title: 'content management system',
        permissions: ['hidden'], // HIDDEN
      },
    ],
  },
  {
    path: 'access-control',
    title: 'Access Control',
    component: UserManagement,
    icon: ShieldCheck,
    withNested: true,
    subRoutes: [
      {
        path: 'user-management',
        component: UserManagement,
        withNested: true,
        title: 'user management',
        permissions: ['user'],
      },
      {
        path: 'roles-and-permissions',
        component: RolesAndPermissions,
        withNested: true,
        title: 'roles and permissions',
        permissions: ['role', 'role_permission', 'user_role', 'permission'],
      },
    ],
  },
];

export default {};
